import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  Chip,
  styled,
  Autocomplete,
  TextField,
  DialogActions,
  Typography,
  DialogContent,
  DialogTitle,
  Dialog,
  Box,
  Alert,
  Snackbar,
  CircularProgress,
  Backdrop
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import { IoMdArrowBack } from 'react-icons/io';
import { DeleteLocationApi, DistrictIdApi, MappingUpdateApi, StateIdApi } from 'API/Mapping/Location_Maping';

const ScrollBox = styled(Box)(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  padding: theme.spacing(1),
  borderRadius: 8,
  maxHeight: 200,
  overflowY: 'auto',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  border: '1px solid #ddd',
  marginTop: '15px'
}));
function Subcard(props) {
  const [StateData, setStateData] = useState([]);
  const [Error, setError] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [DistrictData, setDistrictData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [ValidDistrict, setValidDistrict] = useState(null);
  const [initialStates, setInitialStates] = useState([]);
  const [initialDistricts, setInitialDistricts] = useState([]);
  const ViewData = props.ViewData;

  const stateIds = ViewData?.state_names || [];
  const user_type = ViewData?.usertype || [];
  const user_id = ViewData?.user_id || [];

  const districtIds = ViewData?.district_names || [];
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [RemovedStates, setRemovedStates] = useState([]);
  const [AddedDistricts, setAddedDistricts] = useState([]);

  const getAddedStates = () => {
    return RemovedStates.filter((s) => !initialStates.some((i) => i.state_id === s.state_id));
  };

  const getAddedDistricts = () => {
    return AddedDistricts.filter((d) => !initialDistricts.some((i) => i.district_id === d.district_id));
  };

  const addedStates = getAddedStates();
  const addedDistricts = getAddedDistricts();
  const [DialogData, setDialogData] = useState(null);
  const [DialogValue, setDialogValue] = useState(null);
  const handleOpen = (data, value) => {
    setConfirmDialog(true);
    setDialogData(data);
    setDialogValue(value);
  };

  const handleUpdate = () => {
    if (DialogData === 'addstate') {
      setRemovedStates((prev) => prev.filter((s) => s.state_id !== DialogValue.state_id));
      setValidDistrict(null);

      setAddedDistricts([]);
      setConfirmDialog(false);
    } else if (DialogData === 'adddistrict') {
      setAddedDistricts((prev) => prev.filter((d) => d.district_id !== DialogValue.district_id));
      setConfirmDialog(false);
    } else if (DialogData === 'mapstate') {
      setSelectedStates(selectedStates.filter((s) => s.state_id !== DialogValue.state_id));
      setValidDistrict(null);
      DeleteLocationApi(
        user_id,
        user_type,
        DialogValue.state_id,
        setIsloading,
        setSuccess,
        setError,
        props.refunctiondelete,
        'state',
        setConfirmDialog
      );
    } else if (DialogData === 'mapdistrict') {
      setSelectedDistricts(selectedDistricts.filter((d) => d.district_id !== DialogValue.district_id));
      DeleteLocationApi(
        user_id,
        user_type,
        DialogValue.district_id,
        setIsloading,
        setSuccess,
        setError,
        props.refunctiondelete,
        'district',
        setConfirmDialog
      );
      setValidDistrict(null);
    } else {
      MappingUpdateApi(
        props.Id,
        props.FilterData.user_type,
        addedStates,
        addedDistricts,
        setSuccess,
        setIsloading,
        setError,
        props.refunction,
        props.setDetails,
        setConfirmDialog
      );
    }
  };

  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z]/g, '');
  };

  const hasChanges = () => {
    const stateChanged =
      RemovedStates.length !== initialStates.length || RemovedStates.some((s) => !initialStates.some((i) => i.state_id === s.state_id));

    const districtChanged =
      AddedDistricts.length !== initialDistricts.length ||
      AddedDistricts.some((d) => !initialDistricts.some((i) => i.district_id === d.district_id));

    return stateChanged || districtChanged;
  };

  useEffect(() => {
    StateIdApi(setStateData, setIsLoading);
    // DistrictIdApi(setDistrictData, setIsLoading);
  }, []);

  useEffect(() => {
    setSelectedStates(stateIds);
    setSelectedDistricts(districtIds);
    setInitialStates(stateIds);
    setInitialDistricts(districtIds);
  }, [stateIds, districtIds]);

  return (
    <>
      <Dialog open={confirmDialog} maxWidth="xs" fullWidth>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Typography variant="h3">{`Are you sure you want to ${
            DialogData === 'addstate'
              ? 'remove state?'
              : DialogData === 'adddistrict'
              ? 'remove district?'
              : DialogData === 'mapstate'
              ? 'delete state?'
              : DialogData === 'mapdistrict'
              ? 'delete district?'
              : 'update locations?'
          }`}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDialog(false)}
            sx={{
              // backgroundColor: '#592375',
              color: '#688B2A',
              borderRadius: '6px'
              // '&:hover': {
              //   backgroundColor: '#592375'
              // }
            }}
            color="secondary"
          >
            No
          </Button>
          <Button
            onClick={handleUpdate}
            sx={{
              backgroundColor: '#688B2A',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#688B2A'
              }
            }}
            color="secondary"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop open={Isloading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Success}
        autoHideDuration={5000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setSuccess(false)} variant="filled" severity="success" sx={{ width: '100%' }}>
          {Success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Error}
        autoHideDuration={5000}
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setError(false)} variant="filled" severity="error" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      <SubCard title={`${props.FilterData.user_type.toUpperCase()} Location Details`}>
        <Button
          sx={{ width: '20px' }}
          variant="outlined"
          color="info"
          onClick={() => {
            props.setDetails(false);
            props.setId(null);
          }}
        >
          <IoMdArrowBack style={{ fontSize: '20px' }} />
        </Button>
        <Grid container mt={1} spacing={1}>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <Autocomplete
              disablePortal
              loading={IsLoading}
              options={StateData}
              getOptionLabel={(option) => option.state_name}
              filterOptions={(options, { inputValue }) =>
                options && options.filter((option) => option.state_name.toLowerCase().includes(inputValue.toLowerCase()))
              }
              onChange={(event, value) => {
                if (value) {
                  DistrictIdApi(setDistrictData, setIsLoading, value.state_id);
                  if (value && !RemovedStates.some((item) => item.state_id === value.state_id)) {
                    setRemovedStates((prev) => [...prev, value]);
                    setAddedDistricts([]);
                    setRemovedStates([value]);
                  } else if (!value) {
                    setDistrictData([]);
                    setValidDistrict(null);
                  }
                } else {
                  setDistrictData([]);
                  setValidDistrict(null);
                }
              }}
              renderInput={(params) => <TextField {...params} label={'Select State'} onInput={handleInput} placeholder="Choose state" />}
            />
            <ScrollBox>
              {RemovedStates.length > 0
                ? RemovedStates.map((state, index) => (
                    <Chip
                      key={index}
                      label={state.state_name}
                      sx={{
                        borderColor: '#688B2A',
                        color: '#688B2A'
                      }}
                      onDelete={() => handleOpen('addstate', state)}
                      color="info"
                      variant="outlined"
                    />
                  ))
                : 'No states mapped'}
            </ScrollBox>
          </Grid>
          {props.FilterData.user_type !== 'sh' ? (
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Autocomplete
                disablePortal
                options={DistrictData}
                // disabled={DistrictData.length === 0}
                loading={IsLoading}
                getOptionLabel={(option) => option.district_name}
                filterOptions={(options, { inputValue }) =>
                  options && options.filter((option) => option.district_name.toLowerCase().includes(inputValue.toLowerCase()))
                }
                onChange={(event, value) => {
                  if (value && !AddedDistricts.some((item) => item.district_id === value.district_id)) {
                    setAddedDistricts((prev) => [...prev, value]);
                    setValidDistrict(value.district_id);
                  } else {
                    setValidDistrict(null);
                  }
                }}
                noOptionsText={
                  DistrictData.length === 0 ? (
                    <Box sx={{ textAlign: 'center' }}>No data found. Please select a state</Box>
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>No matching district</Box>
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} label={'Select District'} onInput={handleInput} placeholder="Choose District" />
                )}
              />
              <ScrollBox>
                {AddedDistricts.length > 0
                  ? AddedDistricts.map((district, index) => (
                      <Chip
                        key={index}
                        label={district.district_name}
                        variant="outlined"
                        sx={{
                          borderColor: '#592375',
                          color: '#592375'
                        }}
                        onDelete={() => handleOpen('adddistrict', district)}
                        color="secondary"
                      />
                    ))
                  : 'No districts mapped'}
              </ScrollBox>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
        <Box display={'flex'} justifyContent={'center'} mt={2}>
          <Button
            variant="contained"
            // sx={{ width: '20%', mr: 1 }}
            sx={{
              width: '20%',
              mr: 1,
              backgroundColor: '#592375',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
            disabled={
              RemovedStates.length === 0 ||
              ((props.FilterData.user_type === 'ds' || props.FilterData.user_type === 'mds') &&
                (AddedDistricts.length === 0 || !ValidDistrict)) ||
              !hasChanges()
            }
            onClick={() => handleOpen('', '')}
            color="secondary"
          >
            update
          </Button>
        </Box>
        <Grid container spacing={1}>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
            <Typography variant="h4" mt={2}>
              Mapped State
            </Typography>
            <ScrollBox>
              {selectedStates.length > 0
                ? selectedStates.map((state, index) => (
                    <Chip
                      key={index}
                      label={state.state_name}
                      onDelete={() => handleOpen('mapstate', state)}
                      sx={{
                        borderColor: '#688B2A',
                        color: '#688B2A'
                      }}
                      color="info"
                      variant="outlined"
                    />
                  ))
                : 'No states mapped'}
            </ScrollBox>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
            <Typography variant="h4" mt={2}>
              Mapped District
            </Typography>

            <ScrollBox>
              {selectedDistricts.length > 0
                ? selectedDistricts.map((district, index) => (
                    <Chip
                      key={index}
                      label={district.district_name}
                      variant="outlined"
                      sx={{
                        borderColor: '#592375',
                        color: '#592375'
                      }}
                      onDelete={() => handleOpen('mapdistrict', district)}
                      color="secondary"
                    />
                  ))
                : 'No districts mapped'}
            </ScrollBox>
          </Grid>
        </Grid>
      </SubCard>
    </>
  );
}

export default Subcard;
